import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Contact } from "@models";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class New_ContactsRemote {
	constructor(private readonly apiCallService: ApicallService) {}

	public getContacts(): Observable<Contact[]> {
		return this.apiCallService
			.get("contacts", new ApicallOption(Contact))
			.pipe(map((contacts: Contact[]) => contacts.filter((contact: Contact) => !contact.isDeleted())));
	}
}
